import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Subject } from "rxjs";
import { Message, SpinnerService } from 'shared-components';
import { EtiquetadoService } from "../../../services/etiquetado.service";

@Component({
    selector: 'app-confecciones-pallet',
    templateUrl: './confecciones-pallet.component.html'
})
export class ConfeccionesPalletComponent implements OnInit {

    public newModal = false;
    public editModal = false;
    public deleteModal = false;
    public dropdownInfo: number;

    public showError: boolean;
    public mensajes = new Array<Message>();

    public confeccionPalletId;
    public _confeccionesPallet;

    public pestanaActiva;
    public dropdownSection: number;

    public orderBy: string;
    public idColumn: number;
    public columnFilter: string;

    public denominacionesDuplicarForm: UntypedFormGroup;
    public denominacionesDuplicar = [];
    public duplicarModal = 0;
    public disabledDuplicar: Subject<boolean> = new Subject();
    public confeccionPalletDuplicar;
    public etiquetadorId: number;
    public denominacionesOnFilters;

    public disableOnDuplicate: boolean;

    @Input() set confeccionesPallet(_confecciones){
      this._confeccionesPallet = _confecciones;
      if(this._confeccionesPallet.length != 0) this.getDenominacionesOnFilter();
      this.dropdownInfo = -1;
    };

    @Output() refresh = new EventEmitter<boolean>();
    @Output() sort = new EventEmitter<object>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _translate: TranslateService,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService
    ) {}

    ngOnInit() {
        this.dropdownSection = -1;
        this.dropdownInfo = -1;
        this.denominacionesDuplicarForm = this._fb.group({
          denominacionId: [{value:'', disabledDuplicar: true}, Validators.required],
          denominacionesId: [null]
        });

        this.disableOnDuplicate = this.checkDuplicar();
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public create() {
        this.confeccionPalletId = null;
        this.newModal = true;
    }

    public update(confeccionPallet) {
        this.confeccionPalletId = confeccionPallet.id;
        this.editModal = true;
    }

    public askDelete(confeccionPallet) {
        this.confeccionPalletId = confeccionPallet.id;
        this.deleteModal = true;
    }

    public delete() {
        this.mensajes = [];
        this._spinnerService.showSpinner();
        this._etiquetadoService.deleteConfeccion(this.confeccionPalletId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this.pushMessage('global.success.itemDeleted');
            this.refresh.emit(true);
        });
    }

    public close() {
        this.deleteModal = false;
        this.newModal = false;
        this.editModal = false;
    }

    public pushMessage(mensaje) {
        this.showError = true;
        this.mensajes.push({ class: 'success', message: mensaje });
    }

    public toRefresh(value) {
        this.dropdownSection = -1;
        this.dropdownInfo = -1;
        this.newModal = false;
        this.editModal = false;
        if (value) {
            this.refresh.emit(true);
        }
    }

    public openTabs(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva = 1;
        // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
          // Retardo en caso de que haya otro detalle abierto
          setTimeout(() => {
            document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
          }, 50);
        }
    }

    public showEnvases(i) {
        this.pestanaActiva = 1;
    }

    public toOrderBy(columnFilter, idColumn){
      this.idColumn = idColumn;
      this.columnFilter = columnFilter;
      this.orderBy = !this.orderBy || this.orderBy == 'DESC' ? 'ASC' : 'DESC';
      this.sort.emit({columnFilter: columnFilter, idColumn: idColumn});
    }

    public getIcon(prop: string, idColumn: number) {
      let iconClass = 'fa fa-sort';
      if (this.idColumn && this.columnFilter && this.idColumn === idColumn && this.columnFilter === prop){
        iconClass = this.orderBy === 'DESC' ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public duplicarConfeccion(confeccion){
      this.confeccionPalletDuplicar = confeccion;
      this.denominacionesDuplicar = this.denominacionesOnFilters
      .filter(d=>d.id != confeccion.denominacionIdUnica)
      .map(deno=> {return {'id': deno.id, 'des': deno.des}});
      if (this.denominacionesDuplicar.length === 1) {
        this.denominacionesDuplicarForm.get('denominacionId').patchValue(this.denominacionesDuplicar[0]);
        this.denominacionesDuplicarForm.get('denominacionId').disable();
        this.disabledDuplicar.next(true);
        this.disableOnDuplicate = this.checkDuplicar();
      } else {
        this.denominacionesDuplicarForm.get('denominacionId').enable();
        this.denominacionesDuplicarForm.get('denominacionId').patchValue('');
        this.disabledDuplicar.next(false);
      }
      this.duplicarModal = 1;
    }

    public closeDuplicarModal() {
      this.duplicarModal = 0;
      this.denominacionesDuplicarForm.reset({ denominacionId: '', denominacionesId: '' });
      this.confeccionPalletDuplicar = undefined;
    }

    public shareCheckedListDenominaciones(item: any[]) {
      this.denominacionesDuplicarForm.get('denominacionesId').patchValue(item);
      this.disableOnDuplicate = this.checkDuplicar();
    }

    public onDuplicate(){
      this.mensajes = [];
      let filters = {
        lsConfeccionId: [this.confeccionPalletDuplicar.id],
        lsDenominacionId: []
      };
      if(this.denominacionesDuplicarForm.get('denominacionId').value) {
        filters.lsDenominacionId = [this.denominacionesDuplicarForm.get('denominacionId').value.id];
      }
      if(this.denominacionesDuplicarForm.get('denominacionesId').value) {
        filters.lsDenominacionId = this.denominacionesDuplicarForm.get('denominacionesId').value;
      }
      this._spinnerService.showSpinner();
      this._etiquetadoService.duplicarConfecciones(filters).toPromise().finally(() => {
        this._spinnerService.hideSpinner();
      }).then((response) => {
        if(response.filter(x => x.error).length > 0){
          switch(response.find(x => x.error).error) {
            case 6014: //ConfeccionNoAccesible
              this.showError = true;
              this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.duplicarConfecciones.error.confeccionNoAccesible' });
              break;
            case 6163: //ConfeccionMix
              this.showError = true;
              this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.duplicarConfecciones.error.confeccionMix' });
              break;
            case 6164: //ConfeccionMismaDenominacion
              this.showError = true;
              this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.duplicarConfecciones.error.confeccionMismaDenominacion' });
              break;
            case 6076: //EtiquetadorPaisDenominacionNoAccesible
              this.showError = true;
              this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.duplicarConfecciones.error.etiquetadorPaisDenominacionNoAccesible' });
              break;
            case 6024: //ConfeccionDenominacionNoValidaEnPallet
              this.showError = true;
              this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.duplicarConfecciones.error.confeccionDenominacionNoValidaEnPallet' });
              break;
            case 6165: //ConfeccionYaExiste
              let msg = this._translate.instant('mantenimientoConfecciones.duplicarConfecciones.error.confeccionYaExiste');
              let i = 0;
              response.forEach((element) => {
                if (i == 0) {
                  if (element.error === 6165) {
                    msg += this.denominacionesOnFilters.find(d => d.id == element.denominacionId).des;
                    i = 1;
                  }
                } else {
                  if (element.error === 6165) {
                    msg += ', ' + this.denominacionesOnFilters.find(d => d.id == element.denominacionId).des;
                  }
                }
              });
              this.mensajes.push({ class: 'error', message: msg });
              this.showError = true;
              break;
            default:
              this.showError = true;
              this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
              break;
          }
          this.refresh.emit(true);
        } else{
          this.pushMessage('mantenimientoConfecciones.duplicarConfecciones.success.confeccionDuplicada');
          this.refresh.emit(true);
        }
        this.close();
        this.closeDuplicarModal();
      }, (error) => {
        this.closeDuplicarModal();
        this.showError = true;
        this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
      });
    }

    public checkDuplicar(){
      return this.denominacionesDuplicarForm.get('denominacionId').value == '' &&
        (!this.denominacionesDuplicarForm.get('denominacionesId').value || this.denominacionesDuplicarForm.get('denominacionesId').value == '')
        ? true : false;
    }

    public getDenominacionesOnFilter(){
      if(!this.etiquetadorId) {
        this.etiquetadorId = this._confeccionesPallet[0].etiquetadorId;
      } else {
        if(this.etiquetadorId == this._confeccionesPallet[0].etiquetadorId) return;
      }
      const filters = {
        etiquetadorId: this._confeccionesPallet[0].etiquetadorId,
        tienePDConPermisoConfeccionPallet: true
      };
      this._spinnerService.showSpinner();
      this._etiquetadoService.getAllDenominacionesEtiquetador(filters).toPromise().finally(() => {
        this._spinnerService.hideSpinner();
      }).then((resp) => {
        this.denominacionesOnFilters = resp.lista;
      });
    }

    public showDetails(i: number) {
      this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
      // Desplazamiento a la izquierda para tablet (mismo tamaño máximo que en table.scss)
      if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
        // Retardo en caso de que haya otro detalle abierto
        setTimeout(() => {
            document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
        }, 50);
      }
    }

    public trackByConfeccionId(index: number, confeccionPallet: { id: number }): number {
      return confeccionPallet.id;
    }
}
